import { get, post } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";
import {
  InspectionFormPayload,
  ResidentialInspectionPayload,
} from "../Pages/Inspector/InspectorFi/types/inspector.types";

export const getCommercialInspectionForm = (
  projectId: string,
  drawId: string,
) => get(ENDPOINTS.INSPECTIONS.COMMERCIAL_INSPECTION_FORM(projectId, drawId));

export const getResidentialInspectionForm = (
  projectId: string,
  drawId: string,
) => get(ENDPOINTS.INSPECTIONS.RESIDENTIAL_INSPECTION_FORM(projectId, drawId));

export const saveInspectionForm = (
  projectId: string,
  drawId: string,
  payload: InspectionFormPayload,
  publish: boolean,
) => post(ENDPOINTS.INSPECTIONS.SAVE(projectId, drawId, publish), payload);

export const saveResidentialInspectionForm = (
  projectId: string,
  drawId: string,
  payload: ResidentialInspectionPayload,
  publish: boolean,
) => post(ENDPOINTS.INSPECTIONS.RESIDENTIAL_SAVE(projectId, drawId, publish), payload);

export const getFilePreviewUrl = (key: string) =>
  get(ENDPOINTS.UPLOADS.GET_URL(key));
